"use client"
import { useWindowSize } from '@/hooks/use-window-size'
import { Box, Grid, Skeleton, Stack } from '@mui/material'

export const PromotionCardSkeleton = () => {
  const { width } = useWindowSize()
  const isMobile = width < 640
  return (
    <Grid container spacing={2} overflow={'hidden'} width={'100%'}>
      {Array.from({ length: isMobile ? 2 : 3 }, (_, index) => {
        return (
          <Grid key={index} size={{ xs: 12, sm: 4 }}>
            <Box
              sx={{
                bgcolor: 'background.default',
                p: 1.5,
                borderRadius: 1,
                minWidth: 200,
                display: 'flex',
                flexDirection: 'column',
                gap: { xs: 1, md: 1.5 },
                width: '100%',
              }}
            >
              {/* Header: Offer Badge + Text Skeleton */}
              <Stack direction="row" spacing={0.5} alignItems="center">
                {/* Badge skeleton */}
                <Skeleton variant="rectangular" width={24} height={24} sx={{ borderRadius: 0.5 }} />
                {/* Text skeleton */}
                <Skeleton variant="text" width={120} height={21} sx={{ fontSize: '14px', flex: 1 }} />
              </Stack>

              {/* Price Section Skeleton */}
              <Box sx={{ position: 'relative' }}>
                <Stack direction="row" spacing={0.5} alignItems="baseline">
                  {/* Main price */}
                  <Skeleton
                    variant="text"
                    width={80}
                    height={28}
                    sx={{ fontSize: { xs: '1rem', md: '1.25rem' }, flex: 1 }}
                  />
                </Stack>
              </Box>
            </Box>
          </Grid>
        )
      })}
    </Grid>
  )
}
